import { render, staticRenderFns } from "./deliveryAddress.vue?vue&type=template&id=38d78b66&scoped=true"
import script from "./deliveryAddress.vue?vue&type=script&lang=js"
export * from "./deliveryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d78b66",
  null
  
)

export default component.exports